import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";

const Container = tw.div`relative`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;

const Content = tw.div`mt-16`;

const Card = styled.div((props) => [
  tw`mt-24 md:flex justify-center items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row",
]);
const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded md:w-1/2 lg:w-5/12 xl:w-1/3 flex-shrink-0 h-80 md:h-144 bg-cover bg-center mx-4 sm:mx-8 md:mx-4 lg:mx-8`,
]);
const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-secondary-100`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;
const Link = tw.a`inline-block mt-4 text-sm text-blue-700 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-primary-500`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-blue-700 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-blue-700 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-blue-700 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-blue-700 fill-current w-24`;

export default () => {
  const cards = [
    {
      imageSrc:
        "https://www.sportsnet.ca/wp-content/uploads/2016/05/SPNM05_VLAD01.jpg",
      subtitle: "Like father like son",
      title: "Guerrero and Guerrero JR",
      description:
        "Soon after Blue Jays fans lined up around the block to get their dual bobblehead featuring Vladimir Guerrero and Vladimir Guerrero Jr.﻿, the life-sized versions were on the field together. Vlad Sr. was on hand to throw out the pitch to Vlad Jr. ahead of the Blue Jays.",
    },
    {
      imageSrc:
        "https://cdn.vox-cdn.com/thumbor/3gfNxcjCcRIT-3bD9cyjYul6hgk=/0x0:4871x3247/920x613/filters:focal(2109x574:2887x1352):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/70978925/1240544111.0.jpg",
      subtitle: "The future",
      title: "Scotties Meteoric Rise",
      description:
        "Scottie Barnes, though, doesn’t need much time to win you over. Basically from the second we turned our heads down from the television screen to a YouTube window to watch Florida State highlights, the decision-making was obvious. Barnes was a player who fit the Raptors perfectly — a tall wing skilled enough to play offense in the open floor, able to defend all five positions, and with a jump shot that, with a few years of internal improvement, showed promise. He appeared unpolished, maybe a guy who would take time to adjust to the speed and basketball IQ of an NBA floor, but one who had tremendous upside once everything came together. The early years of Pascal Siakam were an obvious comparison tool. Barnes was a floor-runner and a versatile defender. The rest of his game would come.",
    },
    {
      imageSrc:
        "https://img.mlbstatic.com/mlb-images/image/private/t_16x9/t_w1024/mlb/bdvbdp7kw8nfomsms8mq",
      subtitle: "Power Rankings",
      title: "Who is on top?",
      description:
        "The first three months of the 2022 season are in the books, clubs are nearing the midpoint of the schedule and it’s time for the sixth edition of our Hitter Power Rankings.",
    },
  ];

  return (
    <Container>
      <SingleColumn>
        <HeadingInfoContainer>
          <HeadingTitle>Hot Topics</HeadingTitle>
        </HeadingInfoContainer>

        <Content>
          {cards.map((card, i) => (
            <Card key={i} reversed={i % 2 === 1}>
              <Image imageSrc={card.imageSrc} />
              <Details>
                <Subtitle>{card.subtitle}</Subtitle>
                <Title>{card.title}</Title>
                <Description>{card.description}</Description>
              </Details>
            </Card>
          ))}
        </Content>
      </SingleColumn>
      <SvgDotPattern1 />
      <SvgDotPattern2 />
      <SvgDotPattern3 />
      <SvgDotPattern4 />
    </Container>
  );
};
